import Icon from '@components/dataDisplay/Icons/Icon';
import React, { CSSProperties, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import IconButton from '../button/IconButton';
import Label from '../Input/Label';

const LabelWrapper = styled.label<{
  direction?: 'row' | 'column';
  labelWidth?: string | number;
}>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'column'};
  align-items: ${({ direction }) => direction === 'row' ? 'center' : 'flex-start'};
  gap: ${({ direction }) => direction === 'row' ? '12px' : '4px'};
  width: 100%;

  ${({ direction, labelWidth }) =>
    direction === 'row' && labelWidth && `
      .label-section {
        width: ${typeof labelWidth === 'number' ? `${labelWidth}px` : labelWidth};
        flex-shrink: 0;
      }
      .input-section {
        flex: 1;
      }
    `
  }
`;

const UploadFileButton = styled.div`
  width: 100%;
  label {
    height: 40px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0 12px;
    border-radius: var(--cardBorderRadius);
    border: 1px solid var(--lineColor);
    background-color: var(--cardBackgroundColor);
  }
  // 기존 파일 업로더 숨기기
  input[type='file'] {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;
type Props = {
  id: string;
  accept?: string;
  prevFile?: any;
  setSelectedFile: any;
  deleteFile?: () => void;
  style?: CSSProperties;
  prevFileName?: string;
  customFileChange?: (Blob) => void;
  placeholder?: string;
  label?: string;
  direction?: 'row' | 'column';
  labelWidth?: string | number;
};
function FileUploadInput({
  id,
  accept,
  prevFile,
  setSelectedFile,
  deleteFile,
  prevFileName,
  style,
  customFileChange,
  placeholder = '음악 파일 불러오기',
  label,
  direction = 'column',
  labelWidth
}: Props) {
  const [fileName, setFileName] = useState(prevFileName || '');

  useEffect(() => {
    if (prevFileName) setFileName(prevFileName);
  }, [prevFileName]);

  function handleFileInputChange(e: any) {
    e.preventDefault();
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
      setSelectedFile(file);
    }

    // 파일 용량 제한
    const fileSize = file.size;
    const limit = 30000000; //30MB
    if (fileSize > limit) {
      alert('파일용량은 30mb 를 넘을수 없습니다.');
      return;
    }
    if (customFileChange) customFileChange(file);
  }

  const removeFile = useCallback((e) => {
    e.preventDefault();

    setSelectedFile(null);
    setFileName('');
    if (prevFile) {
      //기존파일 삭제
      if (deleteFile) deleteFile();
    }
  }, []);

  return (
    <LabelWrapper
      direction={direction}
      labelWidth={labelWidth}
      style={{ width: '100%', ...style }}
    >
      {label && (
        <div className="label-section">
          <Label>{label}</Label>
        </div>
      )}
      <UploadFileButton>
        <label htmlFor={id}>
          <Icon name="File14" />
          <div style={{ width: '100%' }}>{fileName || placeholder}</div>
          {fileName && (
            <IconButton icon="X12" onClick={removeFile} shape="default" />
          )}
        </label>
        <input
          type="file"
          id={id}
          value=""
          accept={accept}
          onChange={handleFileInputChange}
          multiple
        />
      </UploadFileButton>
    </LabelWrapper>
  );
}

export default FileUploadInput;
